import { ClockIcon } from '@p2p/assets/svg';
import { addZero } from '@p2p/shared/functions';
import classNames from 'classnames';
import { memo, useMemo } from 'react';

import styles from './Timer.module.scss';
import { TimerProps } from './Timer.types';

const MINUTE = 60;

export const Timer = memo(({ time, className }: TimerProps) => {
  const minutes = addZero(Math.floor((time ?? 0) / 60));
  const seconds = addZero((time ?? 0) % 60);

  const formatTime = useMemo(() => `${minutes}:${seconds}`, [minutes, seconds]);

  if (time === undefined) {
    return null;
  }

  return (
    <div
      className={classNames(
        { [styles.warning]: time < MINUTE * 2 },
        styles.transfer_dialog__header_time_wr,
        className,
      )}
    >
      <ClockIcon />
      <div className={styles.transfer_dialog__header_time}>{formatTime}</div>
    </div>
  );
});
